<template>
    <section class="section a-section a-section--fullheight">
        <div class="container">
            <div
                class="columns is-mobile is-multiline"
                :class="{'is-centered':images.length === 0}"
            >
                <div class="column is-12">
                    <div class="a-flex a-flex--justifyContent-flexStart">
                        <p><b>+ Załadunek</b><br /><small>Dodaj dokumenty. Pozwoli to szybciej rozliczyć.</small></p>
                    </div>
                </div>
                <div class="column is-12">
                    <hr class="a-hr a-hr--noMargin" />
                </div>
                <div
                    class="column is-6 is-relative"
                    v-for="(image, idx) in images"
                    :key="idx"
                >
                    <label
                        :for="`photo_${idx}`"
                        class="a-checkbox__label"
                    >
                        <figure class="image a-image a-image--square a-image--borderRadius">
                            <img :src="image.image" alt="">
                        </figure>
                        <input
                            type="checkbox"
                            :id="`photo_${idx}`"
                            class="a-checkbox__input"
                            :value="image.id"
                            v-model="checkedPhotos"
                        >
                        <div class="a-checkbox__labelWrapper">
                            <div class="a-checkbox__labelContent">
                                <icon-remove />
                            </div>
                        </div>
                    </label>
                </div>
                <div class="column is-6">
                    <button
                        class="button a-button--addPhoto a-button--square"
                        @click="$router.push({ name: 'loading-photo', params: { token } })"
                    >
                        <span class="a-flex a-flex--flexDirection-column a-button__innerBorder a-button__square">
                            <icon-photo />
                            Dodaj zdjęcia dokumentów
                        </span>
                    </button>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="columns">
                <div class="column">
                    <br />
                    <button
                        class="button a-button a-button--dark a-button--marginBottom"
                        @click="remove"
                        v-if="checkedPhotos.length > 0"
                    >
                        <icon-remove-black />
                        Usuń wybrane zdjęcia
                    </button>
                    <br />
                    <button
                        class="button is-primary a-button a-button--medium"
                        @click="submit"
                    >
                        Odebrałem! Przejdź do rozładunku
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import IconRemove from '@/components/icons/Remove'
import IconRemoveBlack from '@/components/icons/RemoveBlack'
import IconPhoto from '@/components/icons/Photo'
export default {
    name: 'Unloading',
    components: {
        IconRemove,
        IconRemoveBlack,
        IconPhoto
    },
    computed: {
        images() {
            return this.$store.getters.loadingPhotos
        },
        token() {
            return this.$store.getters.token
        }
    },
    data() {
        return {
            checkedPhotos: []
        }
    },
    methods: {
        remove() {
            this.$store.dispatch('removeLoadingPhoto', this.checkedPhotos).then(() => {
                this.checkedPhotos = []
            })
        },
        submit() {
            this.$store.dispatch('submitLoading').then(() => {
                this.$router.push({ name: 'unloading', params: { token: this.token } })
            }).catch(e => {
                console.error(e)
                this.$router.push({ name: 'unloading', params: { token: this.token } })
            })
        }
    }
}
</script>
